'use client';

import { useEffect } from 'react';

import posthog from 'posthog-js';
import { PostHogProvider as PHProvider } from 'posthog-js/react';

export function PostHogProvider({ children }: { children: React.ReactNode }) {
  useEffect(() => {
    posthog.init(process.env.NEXT_PUBLIC_POSTHOG_KEY as string, {
      api_host: process.env.NEXT_PUBLIC_POSTHOG_API_HOST,
      ui_host: process.env.NEXT_PUBLIC_POSTHOG_UI_HOST,
      defaults: '2025-11-30'
    });
  }, []);

  return <PHProvider client={posthog}>{children}</PHProvider>;
}
